import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * アプリケーション全体のローディング状態の種類
 * @description
 * - ORGANIZATION_SWITCH: 組織切り替え時のローディング
 * - 他のローディング状態を追加する場合はここに追加
 */
export const LoadingSourceEnum = {
  ORGANIZATION_SWITCH: 'ORGANIZATION_SWITCH'
} as const;
export type LoadingSource = (typeof LoadingSourceEnum)[keyof typeof LoadingSourceEnum];
interface LoadingState {
  isLoading: boolean;
  message?: string;
  source?: LoadingSource;
}
interface LoadingStore extends LoadingState {
  setLoading: (loading: boolean, options?: {
    message?: string;
    source?: LoadingSource;
  }) => void;
}
export const useGlobalLoadingStore = create<LoadingStore>()(devtools(set => ({
  isLoading: false,
  message: undefined,
  source: undefined,
  setLoading: (loading, options = {}) => set({
    isLoading: loading,
    ...options
  }, false, loading ? 'setLoading/start' : 'setLoading/end')
}), {
  name: 'GlobalLoadingStore'
}));